import { render, staticRenderFns } from "./PrfTraceabilityIndex.vue?vue&type=template&id=d653bd44"
import script from "./PrfTraceabilityIndex.vue?vue&type=script&lang=js"
export * from "./PrfTraceabilityIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports